import { PaziaBox } from "components/atoms";
import { HeaderWithBreadcrumbs, PageMain } from "components/molecules";
import { routes } from "consts";
import { CourseGroupBaseForm, CourseGroupFormSchema } from "./CourseGroupBaseForm";
import { getApiErrorMessage, useToaster } from "utils";
import { coursegroupsApi } from "api";
import { useNavigate } from "react-router-dom";

export const CourseGroupAddPage = () => {
  const { showError, showSuccess } = useToaster();
  const navigate = useNavigate();
  const breadcrumbs = [{ title: "Grupy kursów", path: routes.COURSE_GROUPS }, { title: "Tworzenie nowej grupy" }];

  const onSubmit = async (data: CourseGroupFormSchema) => {
    try {
      const response = await coursegroupsApi.create(data);
      const id = response.data;
      navigate(routes.COURSE_GROUPS_EDIT_PREVIEW(id.toString()));
      showSuccess("Grupa kursów została dodana");
    } catch (e) {
      showError(getApiErrorMessage(e, "Nie udało się dodać grupy kursów"));
    }
  };
  return (
    <PageMain>
      <HeaderWithBreadcrumbs breadcrumbs={breadcrumbs} headerText="Tworzenie nowej grupy" />
      <PaziaBox>
        <CourseGroupBaseForm onSubmit={onSubmit} />
      </PaziaBox>
    </PageMain>
  );
};
